import { apiAxiosCMS } from 'services/api';

export async function deleteBlogReq(id: string) {
	return await apiAxiosCMS
		.delete(`/blog/${id}`)
		.then(() => {
			return true;
		})
		.catch((error) => {
			console.error('✌️error --->', error);
			return false;
		});
}
